import { ReactComponent as CheckmarkIcon } from "./assets/images/checkmark.svg"
import { ReactComponent as ExclamationIcon } from "./assets/images/exclamation.svg"
import { ReactComponent as HourglassIcon } from "./assets/images/hourglass.circle.svg"
import { ReactComponent as UturnIcon } from "./assets/images/uturn.circle.svg"
import { OrderStatus } from "./types"
import { logAnalyticsEvent } from "./utils/helpers"

// ORDER STATUS ICON (see: https://docs.google.com/spreadsheets/d/1QPr1g9VLqQoL7XtwXFy_4xIkG6dg3XYD8LIIwowABak/edit?gid=1085922130#gid=1085922130)
export function parseIcon(status?: OrderStatus): JSX.Element | undefined {
    const iconStyle = { fill: 'white' }
    switch (status) {
        case 'processing':
        case 'refund-processing':
            return <HourglassIcon className="me-1" style={iconStyle} />
        case 'paid':
        case 'refunded':
            return <CheckmarkIcon className="me-1" style={iconStyle} />
        case 'cancelled':
        case 'refund-cancelled':
            return <UturnIcon className="me-1" style={iconStyle} />
        case 'failed':
        case 'refund-failed':
            return <ExclamationIcon className="me-1" style={iconStyle} />
        default:
            logAnalyticsEvent({ type: 'internal-error', message: `parseIcon got unknown status: ${status}` })
            return
    }
}


/// USER MESSAGE (see: https://docs.google.com/spreadsheets/d/1QPr1g9VLqQoL7XtwXFy_4xIkG6dg3XYD8LIIwowABak/edit?gid=1085922130#gid=1085922130)
export function parseUserMessage(status?: OrderStatus): string | undefined {
    switch (status) {
        case 'processing':
            return "Your payment is being processed.\nYour Parlay P account should be active."
        case 'paid':
            return "Your payment was successful!\nThank you for your purchase."
        case 'cancelled':
            return "Your payment was cancelled."
        case 'failed':
            return "Your payment could not be processed.\nPlease contact support for assistance."
        case 'refund-processing':
            return "Your refund is being processed."
        case 'refunded':
            return "Your refund was completed successfully.\nThe funds should appear in your account shortly."
        case 'refund-cancelled':
            return "Your refund was cancelled.\nIf you need help, contact support."
        case 'refund-failed':
            return "Your refund could not be processed.\nPlease contact support for assistance."
        default:
            logAnalyticsEvent({ type: 'internal-error', message: `parseUserMessage got unknown status: ${status}` })
            return undefined
    }
}
